import React from 'react'

export const Footer = () => {
  return (
    <div className='h-20 flex justify-center items-center'>
      Sportify © 2022
    </div>
  )
}
